import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Header from "../common/Header";
import $ from "jquery";
import useAuth from "../../hooks/useAuth";
import { POSTREQUEST } from "../helpers/ServiceRequest";

function InsertUser() {
  const [email, setEmail] = useState("");
  const [emailErr, setEmailErr] = useState(false);
  const [firstName, setFirstName] = useState("");
  const [firstNameErr, setFirstNameErr] = useState(false);
  const [lastName, setLastName] = useState("");
  const [lastNameErr, setLastNameErr] = useState(false);
  const [userName, setUserName] = useState("");
  const [userNameErr, setUserNameErr] = useState(false);
  const [role, setRole] = useState("");
  const [roleErr, setRoleErr] = useState(false);
  const [password, setPassword] = useState("");
  const [passwordErr, setPasswordErr] = useState(false);
  const [confirmPassword, setConfirmPassword] = useState("");
  const [confirmPasswordErr, setConfirmPasswordErr] = useState(false);
  const [current, setCurrent] = useState(1);
  const [errorMessage, setErrorMessage] = useState("");
  const [disabled, setDisabled] = useState(false);

  useEffect(() => {
    var headerHeight = $("header").outerHeight();
    var mainHeight = $(window).height() - headerHeight;
    $("main").height(mainHeight);
    $("main").css("margin-top", headerHeight + "px");
  });
  let navigate = useNavigate();
  const { user } = useAuth();
  const addUser = async(e) => {
    e.preventDefault();
    setDisabled(true);
    let URL = process.env.REACT_APP_API_URL + "/create-user";
    if (
      email == "" &&
      firstName == "" &&
      lastName == "" &&
      userName == "" &&
      role == "" &&
      password == ""
    ) {
      setEmailErr(true);
      setFirstNameErr(true);
      setLastNameErr(true);
      setUserNameErr(true);
      setRoleErr(true);
      setPasswordErr(true);
      return false;
    }
    let payload = {
      Email: email,
      FirstName: firstName,
      LastName: lastName,
      UserName: userName,
      Role: role,
      Password: password,
      ConfirmPassword: confirmPassword,
      Current: parseInt(current),
    };
    if (
      email != "" &&
      firstName != "" &&
      lastName != "" &&
      userName != "" &&
      role != "" &&
      password != ""
    ) {
      let response = await POSTREQUEST(URL, payload, user.jwtToken);
      if (response?.data) {
        navigate("/users");
      } else {
        setErrorMessage(response?.error?.message);
      }
    } else if (email == "") {
      setEmailErr(true);
      return false;
    } else if (firstName == "") {
      setFirstNameErr(true);
      return false;
    } else if (lastName == "") {
      setLastNameErr(true);
      return false;
    } else if (userName == "") {
      setUserNameErr(true);
      return false;
    } else if (role == "") {
      setRoleErr(true);
      return false;
    }
  };
  return (
    <React.Fragment>
      <Header />
      <main className="bg-lite-grey overflow-auto">
        <section className="px-4 pt-3 pb-4">
          <div className="table-elements">
            <nav style={{ ariaLabel: "breadcrumb" }}>
              <ol className="breadcrumb">
                <li className="breadcrumb-item fs-15">
                  <Link
                    to="/users"
                    className="text-decoration-none text-primary"
                  >
                    Users
                  </Link>
                </li>
                <li
                  className="breadcrumb-item fs-15 active"
                  aria-current="page"
                >
                  Add New User
                </li>
              </ol>
            </nav>
          </div>
          <div className="row justify-content-center">
            <div className="width-xxl-35 width-xl-44 width-lg-60 width-md-80">
              <div className="card p-4">
                <div className="card-header bg-white border-bottom-0">
                  <h1 className="title-semibold fs-24 mb-1">Add User</h1>
                  <p className="text-lite fs-15 mb-0">
                    Please enter details to add new user
                  </p>
                </div>
                <form onSubmit={addUser}>
                  <div className="card-body">
                    <div className="cmb-15 row g-3">
                      <label className="width-sm-35 d-flex align-items-center fs-15 text-dark text-nowrap">
                        Email
                      </label>
                      <div className="col">
                        <input
                          type="email"
                          className={
                            "form-control input-md " +
                            (emailErr ? " is-invalid" : "")
                          }
                          placeholder="Enter Email"
                          onChange={(e) => {
                            setEmailErr(false);
                            setEmail(e.target.value);
                          }}
                        />
                      </div>
                    </div>
                    <div className="cmb-15 row g-3">
                      <label className="width-sm-35 d-flex align-items-center fs-15 text-dark text-nowrap">
                        User Name
                      </label>
                      <div className="col">
                        <input
                          type="text"
                          className={
                            "form-control input-md " +
                            (userNameErr ? " is-invalid" : "")
                          }
                          placeholder="Enter User Name"
                          onChange={(e) => {
                            setUserNameErr(false);
                            setUserName(e.target.value);
                          }}
                        />
                      </div>
                    </div>
                    <div className="cmb-15 row g-3">
                      <label className="width-sm-35 d-flex align-items-center fs-15 text-dark text-nowrap">
                        First Name
                      </label>
                      <div className="col">
                        <input
                          type="text"
                          className={
                            "form-control input-md " +
                            (firstNameErr ? " is-invalid" : "")
                          }
                          placeholder="Enter First Name"
                          onChange={(e) => {
                            setFirstNameErr(false);
                            setFirstName(e.target.value);
                          }}
                        />
                      </div>
                    </div>
                    <div className="cmb-15 row g-3">
                      <label className="width-sm-35 d-flex align-items-center fs-15 text-dark text-nowrap">
                        Last Name
                      </label>
                      <div className="col">
                        <input
                          type="text"
                          className={
                            "form-control input-md " +
                            (lastNameErr ? " is-invalid" : "")
                          }
                          placeholder="Enter Last Name"
                          onChange={(e) => {
                            setLastNameErr(false);
                            setLastName(e.target.value);
                          }}
                        />
                      </div>
                    </div>
                    <div className="cmb-15 row g-3">
                      <label className="width-sm-35 d-flex align-items-center fs-15 text-dark text-nowrap">
                        Password
                      </label>
                      <div className="col">
                        <input
                          type="password"
                          className={
                            "form-control input-md " +
                            (passwordErr ? " is-invalid" : "")
                          }
                          placeholder="Enter Password"
                          onChange={(e) => {
                            setPasswordErr(false);
                            setPassword(e.target.value);
                          }}
                        />
                      </div>
                    </div>
                    <div className="cmb-15 row g-3">
                      <label className="width-sm-35 d-flex align-items-center fs-15 text-dark text-nowrap">
                        Confirm Password
                      </label>
                      <div className="col">
                        <input
                          type="password"
                          className={
                            "form-control input-md " +
                            (confirmPasswordErr ? " is-invalid" : "")
                          }
                          placeholder="Enter Confirm Password"
                          onChange={(e) => {
                            setPasswordErr(false);
                            setConfirmPassword(e.target.value);
                            if (password != e.target.value) {
                              setConfirmPasswordErr(true);
                              setDisabled(true);
                            } else {
                              setConfirmPasswordErr(false);
                              setDisabled(false);
                            }
                          }}
                        />
                      </div>
                    </div>
                    <div className="cmb-15 row g-3">
                      <label className="width-sm-35 d-flex align-items-center fs-15 text-dark text-nowrap">
                        Role
                      </label>
                      <div className="col">
                        <select
                          className={
                            "form-select input-md " +
                            (roleErr ? "is-invalid" : "")
                          }
                          aria-label="Default select example"
                          onChange={(e) => {
                            setRoleErr(false);
                            setRole(e.target.value);
                          }}
                        >
                          <option value="">Select Role</option>
                          <option value="Admin">Admin</option>
                        </select>
                      </div>
                    </div>
                    <div className="cmb-15 row g-3">
                      <label className="width-sm-35 d-flex align-items-center fs-15 text-dark text-nowrap">
                        Status
                      </label>
                      <div className="col">
                        <select
                          className="form-select input-md "
                          aria-label="Default select example"
                          onChange={(e) => {
                            setCurrent(e.target.value);
                          }}
                        >
                          <option value={1}>Active</option>
                          <option value={0}>Inactive</option>
                        </select>
                      </div>
                    </div>
                    {errorMessage && (
                      <div className="text-danger text-center">
                        {" "}
                        {errorMessage}{" "}
                      </div>
                    )}
                  </div>
                  <div className="card-footer bg-white d-flex p-3 border-top-0">
                    <div className="d-grid w-100">
                      <button
                        type="submit"
                        className="btn btn-secondary btn-md text-white d-flex align-items-center justify-content-center px-4 fw-medium rounded-3 mx-1"
                      >
                        Add User
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </section>
      </main>
    </React.Fragment>
  );
}

export default InsertUser;
